import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { DynamicsBasedContactSyncSettings } from './DynamicsBasedContactSyncSettings'

export const DynamicsBasedSpecificSettings = (serviceId: IntegrationServiceId): ClickNavigationSection[] => {
  return [{ id: 'sync', label: 'Sync', content: () => <DynamicsBasedContactSyncSettings serviceId={serviceId} /> }]
}
